<template>
  <div>
    <v-overlay :value="loading" class="align-center justify-center">
      <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-snackbar v-model="error.show">
      <p class="py-0 my-0 font-weight-black">{{ error.title }}</p>
      {{ error.message }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="error.show = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>

    <v-container class="ma-0" fluid>
      <v-data-table :headers="headers" :items="tickets" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
        class="elevation-1" :loading="loadingLista" loading-text="Carregando..." :search="pesquisar"
        @dblclick:row="($event, { item }) => abrirTicket(item.url)" :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50, 100, -1],
        }" :items-per-page="12" locale="pt" item-key="id">

        <template v-slot:top>
          <v-toolbar flat v-if="!loadingLista">
            <v-text-field v-model="pesquisar" append-icon="mdi-magnify" label="Pesquisar" single-line hide-details>
            </v-text-field>

            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="grey" dark class="mb-2 ml-2" v-bind="attrs" v-on="on" @click="atualizar()">
                  <v-icon small>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>Atualizar lista</span>
            </v-tooltip>
          </v-toolbar>
        </template>

        <template v-slot:item.idShort="{ item }">
          <span class="font-weight-bold">#{{ item.idShort }}</span>
        </template>

        <template v-slot:item.dateLastActivity="{ item }">
          <span>{{ formatarData(item.dateLastActivity) }}</span>
        </template>

        <template v-slot:item.closed="{ item }">
          <v-chip :color="item.closed ? 'red' : 'green'" small dark>
            {{ item.closed ? 'Fechado' : 'Aberto' }}
          </v-chip>
        </template>

        <template v-slot:item.opcoes="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" color="blue" v-bind="attrs" v-on="on" @click="visualizarDescricao(item)">
                mdi-eye
              </v-icon>
            </template>
            <span>Ver descrição</span>
          </v-tooltip>
        </template>

      </v-data-table>
    </v-container>

    <v-dialog v-model="dialogDescricao" max-width="700px">
      <v-card>
        <v-card-title class="blue white--text">
          <v-icon left color="white">mdi-ticket-account</v-icon>
          <span class="headline">Descrição do ticket #{{ ticketSelecionado.idShort }}</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogDescricao = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <div class="text-h6 mb-2">{{ ticketSelecionado.name }}</div>
          <v-divider class="mb-3"></v-divider>
          <div v-if="ticketSelecionado.desc" v-html="formatarDescricao(ticketSelecionado.desc)" class="ticket-desc"></div>
          <div v-else class="grey--text">Sem descrição</div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue" text @click="dialogDescricao = false">
            Fechar
          </v-btn>
          <v-btn color="blue" dark @click="abrirTicket(ticketSelecionado.url)">
            <v-icon left small>mdi-open-in-new</v-icon>
            Abrir no Trello
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { listarTickets } from "../../services/api";

export default {
  name: "Tickets",
  data: () => ({
    loading: false,
    loadingLista: false,
    tickets: [],
    pesquisar: "",
    sortBy: 'dateLastActivity',
    sortDesc: true,
    dialogDescricao: false,
    ticketSelecionado: {},
    error: {
      show: false,
      title: "",
      message: "",
    },
    headers: [
      {
        text: "ID",
        align: "start",
        value: "idShort",
        width: "100px"
      },
      {
        text: "Título",
        value: "name",
      },
      {
        text: "Última atividade",
        value: "dateLastActivity",
        width: "200px"
      },
      {
        text: "Status",
        value: "closed",
        width: "120px"
      },
      {
        text: "Opções",
        value: "opcoes",
        sortable: false,
        align: "center",
        width: "100px"
      },
    ],
  }),
  mounted() {
    this.carregarTickets();
  },
  methods: {
    setError(title, message = "") {
      this.error.title = title;
      this.error.message = message;
      this.error.show = true;
    },
    async carregarTickets() {
      try {
        this.loadingLista = true;
        const token = localStorage.getItem("token");

        if (!token) {
          this.setError("Erro", "Token não encontrado. Faça login novamente.");
          return;
        }

        const response = await listarTickets(token);

        if (response.data && response.data) {
          this.tickets = response.data.map(ticket => ({
            id: ticket.id,
            idShort: ticket.idShort,
            name: ticket.name,
            desc: ticket.desc,
            url: ticket.url,
            dateLastActivity: ticket.dateLastActivity,
            closed: ticket.dueComplete,
          }));
        } else {
          this.tickets = [];
        }
      } catch (error) {
        console.error("Erro ao carregar tickets:", error);
        this.setError("Erro ao carregar tickets", error.message);
      } finally {
        this.loadingLista = false;
      }
    },
    atualizar() {
      this.carregarTickets();
    },
    abrirTicket(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
    formatarData(dataISO) {
      if (!dataISO) return "-";

      const data = new Date(dataISO);

      data.setHours(data.getHours() - 3);

      return data.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    },
    visualizarDescricao(ticket) {
      this.ticketSelecionado = ticket;
      this.dialogDescricao = true;
    },
    formatarDescricao(desc) {
      if (!desc) return "";
      return desc.replace(/\n/g, "<br>");
    }
  },
};
</script>

<style scoped>
.ticket-desc {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.6;
}
</style>
